const CaretDoubleUpWhite = ({
  width = '25',
  height = '24',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9921_5694)">
        <path
          d="M6.95114 1.61351C7.60006 1.23886 8.39956 1.23886 9.04848 1.61351L13.0056 3.89817C13.6546 4.27283 14.0543 4.96522 14.0543 5.71452V10.2839C14.0543 11.0332 13.6546 11.7255 13.0056 12.1002L9.04848 14.3849C8.39956 14.7595 7.60006 14.7595 6.95114 14.3849L2.99398 12.1002C2.34506 11.7255 1.94531 11.0332 1.94531 10.2839V5.71452C1.94531 4.96522 2.34506 4.27283 2.99398 3.89817L6.95114 1.61351Z"
          fill="white"
        />
        <path
          d="M10.3337 7.55474L8.00033 5.33252L5.66699 7.55474"
          stroke="#A256BC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3337 10.2212L8.00033 7.99902L5.66699 10.2212"
          stroke="#A256BC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9921_5694">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default CaretDoubleUpWhite;
